import { useAppState } from "./useReduxState"
import { FetchState } from "../Models/Client/FetchState"
import { selectAssumedRoles } from "../Helpers/Functions/Selectors/collaborator"
import { useAppInstance } from "./useAppInstance"
import { ProjectRole } from "../Models/Client/ProjectRole"

/**
 * Returns *assumed* roles for various operations.
 * Read docs of `selectAssumedRoles` for more details.
 */
export function useAssumedRoles(appID?: string): FetchState<ProjectRole[]> {
    const rolesFetch = useAppState(state =>
        appID ? selectAssumedRoles(state, appID) : undefined
    )

    // trigger fetching app if not fetched yet
    useAppInstance(appID)

    return rolesFetch
}
